/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import './GovBrTable.css';

import { GovBrPagination } from 'components';
import { EmptyFieldWarning } from 'pages/EHRPage/components/EmptyFieldWarning';
import { TableHeader } from './TableHeader';
import { TableBody } from './TableBody';

// eslint-disable-next-line object-curly-newline
export function GovBrTable({ header, body, selected, setSelected, checkbox }) {
  const [tableRows, setTableRows] = useState([]);
  const [itensPerPage, setItensPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const pages = Math.ceil(body.length / itensPerPage);
  const startIndex = currentPage * itensPerPage;
  const endIndex = startIndex + itensPerPage;

  const handleSelectAll = (e) => {
    const selectAll = {};
    const filterDisabled = tableRows?.filter((el) => !el.value.disabled);

    filterDisabled.forEach((item) => {
      // Pega apenas o primeiro elemento do array local_id
      const localId = Array.isArray(item.value.local_id)
        ? item.value.local_id[0]
        : item.value.local_id;

      selectAll[localId] = e.target.value === 'false';
    });
    setSelected(selectAll);
  };

  useEffect(() => {
    setTableRows(
      body?.map((el, index) => ({
        id: index,
        value: {
          ...el,
          // Garante que local_id seja sempre o primeiro elemento do array
          local_id: Array.isArray(el.local_id) ? el.local_id[0] : el.local_id,
        },
      })),
    );
  }, [body]);

  return (
    <>
      {body?.length ? (
        <div className="br-table px-2">
          <table>
            <TableHeader
              columns={header?.map((el) => el.display)}
              selected={selected}
              setSelected={setSelected}
              teste={handleSelectAll}
              checkbox={checkbox}
            />
            <TableBody
              rows={tableRows.slice(startIndex, endIndex)}
              selected={selected}
              setSelected={setSelected}
              path={header?.map((el) => el.path)}
              checkbox={checkbox}
            />
          </table>
          {body.length > 0 && (
            <GovBrPagination
              items={itensPerPage}
              totalItens={body.length}
              setItensPerPage={setItensPerPage}
              setCurrentPage={setCurrentPage}
              pages={pages}
              currentPage={currentPage}
            />
          )}
        </div>
      ) : (
        <EmptyFieldWarning />
      )}
    </>
  );
}
